module.exports = __webpack_public_path__ + "img/check-circle.45090fd7.svg";